import React from 'react'
import EmbedContactForm from 'components/shared/EmbedContactForm'
import ContactForm from 'components/shared/ContactForm'

const ContactFormSwitch = ({ className, embedForm, intro }) => {
  if (embedForm.isEmbed) {
    return (
      <EmbedContactForm
        className={className}
        formIntro={intro}
        {...embedForm}
      />
    )
  }

  return <ContactForm className={className} formIntro={intro} {...embedForm} />
}

export default ContactFormSwitch
